export default "__VITE_PUBLIC_ASSET__9eade542__"